export const env = {
    backendUrl: 'https://api.app.getchef.fr/api/',
}
